module.exports = __webpack_public_path__ + "static/media/monserat.8f16be55.jpg";